import React, { useState, useRef } from 'react';
import { useColorMode } from '@lux/core';
import { ThemeProvider } from 'styled-components';
import { useUIDSeed } from 'react-uid';
import { AssistiveText } from '../assistive-text';
import { getAriaLabelsForControl } from '../helpers';
import { InputWrapper, LabelWrapper, FieldWrapper, PrefixWrapper, SuffixWrapper, TextFieldWrapper, } from './styles';
import { TextFieldState, TextFieldType } from './types';
const getFieldState = (value, disabled, error) => {
    if (disabled)
        return TextFieldState.DISABLED;
    if (error)
        return TextFieldState.ERROR;
    if (!value)
        return TextFieldState.EMPTY;
    return TextFieldState.DEFAULT;
};
const _TextField = ({ id, label, placeholder = '', initialValue, value, type = TextFieldType.DEFAULT, error, errorMessage, disabled, prefix, suffix, onChange, onFocus, onBlur, halfBorder = { left: false, right: false }, hint, multiLine = false, ...rest }, ref) => {
    const theme = useColorMode();
    const selfUID = useUIDSeed()('text-input');
    const componentId = id || selfUID;
    const ariaIds = getAriaLabelsForControl(componentId, error, errorMessage, hint);
    const [controlledValue, setControlledValue] = useState(value || initialValue || '');
    const [focused, setFocused] = useState(false);
    const { current: isControlled } = useRef(value !== null && value !== undefined);
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
        if (!isControlled) {
            setControlledValue(event.target.value);
        }
    };
    const handleFocus = (event) => {
        if (onFocus) {
            onFocus(event);
        }
        setFocused(true);
    };
    const handleBlur = (event) => {
        if (onBlur) {
            onBlur(event);
        }
        setFocused(false);
    };
    const finalValue = isControlled ? value : controlledValue;
    const fieldState = getFieldState(finalValue, disabled, error);
    return (React.createElement(ThemeProvider, { theme: { fieldState, ...theme } },
        React.createElement(TextFieldWrapper, null,
            label && React.createElement(LabelWrapper, { htmlFor: componentId }, label),
            React.createElement(FieldWrapper, { focused: focused, fieldState: fieldState, halfBorder: halfBorder, multiLine: multiLine },
                !multiLine && prefix && React.createElement(PrefixWrapper, null, prefix),
                React.createElement(InputWrapper, Object.assign({ ref: ref, id: componentId, placeholder: placeholder, value: finalValue, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, type: multiLine ? '' : type, disabled: disabled, as: multiLine ? 'textarea' : 'input', "aria-invalid": error, "aria-describedby": ariaIds.ariaDescribedBy }, rest)),
                !multiLine && suffix && React.createElement(SuffixWrapper, null, suffix)),
            React.createElement(AssistiveText, { id: ariaIds.describeId, error: error, errorMessage: errorMessage, hint: hint }))));
};
const TextField = React.forwardRef(_TextField);
export default TextField;
//# sourceMappingURL=component.js.map